import storefrontInstance from '@/api/instances/storefront';
import {axiosToast} from '@/utils/axios';
const initInterceptors = function (notify) {
  storefrontInstance.interceptors.response.use(
    (response) => {
      const {data, config} = response;
      const useToast = config.toast ?? true;
      if (useToast) {
        axiosToast(data, notify);
      }

      return response;
    },

    (error) => {
      const {data} = error.response;

      axiosToast(data, notify);

      return Promise.reject(error);
    }
  );
};
export {initInterceptors};
